import moment from "moment-timezone";

let eventLoopService = {}
eventLoopService.install = function (Vue, options) {

  const EVENT_LOOP_TAG = 'EVENT_LOOP_TAG';
  // const ACTION_TIME_TAG = 'ACTION_TIME_TAG'

  const TIMEOUT = 300000; //Stop event loop after 5 min after user has left view
  const EVENT_TIMEOUT = 60000; // Call loop function every 60 seconds

  let self=this;
  let timezone;

  let queueLoop;
  let isRunning=false;
  let focusPointer=null;

  let timestampMapper = [];

  if (null == options){
    console.error('Can not start eventLoop service. Options are not defined');
    return;
  }

  Vue.prototype.$eventLoop = {};
  Vue.prototype.$eventLoop.stop = () => {
    this.destroy();
  }

  Vue.prototype.$eventLoop.start = () => {
    this.startLoop();
    this.initBackgroundListener();
  }

  Vue.prototype.$eventLoop.setGroupActionTimeList = (timeList) => {
    if (timeList) {
      this.groupActionTimeListSet(timeList)
    }
  }

  Vue.prototype.$eventLoop.setTimezone = (timezone) => {
    this.setTimezoneInternal(timezone)
  }

  this.onError = function(tick) {
    console.error(tick);
  }

  this.destroy = function() {
    this.destroyBackgroundListener()
    this.stopLoop();
  }

  this.startLoop = function() {
    if (!isRunning) {
      console.log('Start event loop');
      isRunning = true;

      //Execute loop function every 60 seconds
      timestampMapper.push({name: EVENT_LOOP_TAG, stamp : this.getEventLoopTimestamp()});

      //Execute loop after 10s initially
      queueLoop = setTimeout(() => {
        this.execute();
      }, 10000);
    }
  }

  this.stopLoop = function() {
    console.log('Stop event loop');
    isRunning=false;
    clearTimeout(queueLoop)
    queueLoop=null;
  }

  this.restartLoop = function () {
    if (isRunning) {
      clearTimeout(queueLoop)
      this.continueLoop()
    }
  }

  this.continueLoop = function () {
    if (isRunning) {
      queueLoop = setTimeout(() => {
        this.execute();
      }, this.getDelayOfTimestamp(this.getSmallestTimestamp()));
    }
  }

  this.execute = function() {
    console.log('execute');

    let hasActionTimestamp = false;
    let currentTimestamp = this.getCurrentTimestamp();
    let finished = timestampMapper.filter(stamp => {
      return stamp.stamp <= currentTimestamp
    });

    // remove finished timestamps
    timestampMapper = timestampMapper.filter(function(value){
      return !finished.includes(value);
    });

    finished.forEach(stamp => {
      if (stamp.name === EVENT_LOOP_TAG) {
        if (Vue._.isFunction(options.refreshEvent)) {
          options.refreshEvent();
        }
        timestampMapper.push({name: EVENT_LOOP_TAG, stamp : this.getEventLoopTimestamp()});
      } else {
        hasActionTimestamp = true;
      }
    })

    if (hasActionTimestamp) {
      if (Vue._.isFunction(options.refreshSpotList)) {
        options.refreshSpotList();
      }
    }
    this.continueLoop()
  }

  this.getSmallestTimestamp = function () {
    let smallest;
    timestampMapper.forEach(timestamp => {
      if (!smallest || (timestamp && timestamp.stamp <= smallest)) {
        smallest = timestamp.stamp;
      }
    })
    return smallest;
  }

  this.getDelayOfTimestamp = function (timestamp) {
    let currTime = this.getCurrentTimestamp();
    let delay = timestamp - currTime;
    if (delay < 0) {
      delay = EVENT_TIMEOUT;
    }
    return delay;
  }

  this.setTimezoneInternal = function (timez) {
    timezone = timez;
    if (timezone) {
      timestampMapper.push({name: EVENT_LOOP_TAG, stamp : this.getEventLoopTimestamp()});
      this.restartLoop()
    }
  }

  this.groupActionTimeListSet = function(timeList) {
    let eventStamp = timestampMapper.find(stamp => stamp.name === EVENT_LOOP_TAG)
    let eventTimestamp = eventStamp? eventStamp.stamp: this.getEventLoopTimestamp();
    timestampMapper = [];
    timestampMapper.push.apply(timestampMapper, timeList);
    timestampMapper.push({name: EVENT_LOOP_TAG, stamp: eventTimestamp});
    this.restartLoop();
  }

  this.getEventLoopTimestamp = function () {
    return this.getTimestampWithOffset(EVENT_TIMEOUT);
  }

  this.getCurrentTimestamp = function () {
    return this.getTimestampWithOffset(0);
  }

  this.getTimestampWithOffset = function (offset) {
    let date= new Date(new Date().getTime() + offset);
    return Date.parse(moment.tz(date, timezone).format());
  }

  /* Tab Management */
  this.onBlur = function() {
    console.log('onBlur');
    self.stopLoop();
  }

  this.onBlurDelayed = function() {
    if (focusPointer) {
      clearTimeout(focusPointer);
    }
    focusPointer = setTimeout(() => {
      self.onBlur();
    }, TIMEOUT);
  }

  this.onFocus = function() {
    console.log('onFocus');
    self.startLoop();
  }

  this.destroyBackgroundListener = function() {
    window.removeEventListener('focus', this.onFocus);
    window.removeEventListener('blur', this.onBlurDelayed);
  }

  this.initBackgroundListener = function() {
    window.addEventListener('focus', this.onFocus);
    window.addEventListener('blur', this.onBlurDelayed);
  }
}

export default eventLoopService

